import { render, staticRenderFns } from "./Advert.vue?vue&type=template&id=08b1ce6e&"
import script from "./Advert.vue?vue&type=script&lang=js&"
export * from "./Advert.vue?vue&type=script&lang=js&"
import style0 from "./Advert.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports